module.exports = __webpack_public_path__ + "static/media/slack-black.e85cc253.svg";